import React, { useState } from 'react';
import { Grid, Typography, Breadcrumbs } from '@mui/material';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import {Waypoint} from 'react-waypoint'
import Testimonial from '../testimonial';
import FootPrint from '../../footprint';
// import ProjectSlick from '../projects';

const HtltService = () => {

    const [numberBool, setNumberBool] = useState(false);

    const slides = [
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/electrical/stt-e.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>STT, Mumbai</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Navi Mumbai, Maharashtra</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/electrical/atc-e.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>ATC Tower, Kolkata Airport</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Kolkata, West Bengal</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/electrical/goa-e.png' alt='Goa Airport' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>MOPA International Airport</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Goa</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/electrical/bhita-e.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>ESIC Medical College & Hospital, Bihta</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Patna, Bihar</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/electrical/sky-e.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>Sky Mansion, New Delhi</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Chattarpur, New Delhi</Typography>
        </Grid>
        
    ]
    
return (
    <Grid item xs={12} sx={{width:'100%'}}>
        <Grid item xs={12} sx={{display: 'flex', flexFlow: 'column', alignItems:'center'}}>
            <Grid item className='title-div'
                // sx={{px:10, width:'100%', maxWidth:1440, display:'flex', justifyContent:'center', pt:'2em'}}
            >
                <Grid item sx={{px:!isMobile && 12.5, background: !isMobile && 'url(/assets/images/hvacbg.png) no-repeat', backgroundPosition:'bottom right'}}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to={'/'} className='normal-text title-color' style={{textDecoration:'none'}} >Home</Link>
                        <Link to={'/services'} className='normal-text title-color' style={{textDecoration:'none'}} >Services</Link>
                        <Typography variant='body2' component={'p'} sx={{color:'#535353'}}>Electrical</Typography>
                    </Breadcrumbs>
                    <Grid item xs={12} sx={{pt:'2em',pb:'8em'}}>
                        <Typography variant='body2' component={'h5'} className='titleStyle title-color' sx={{ pb:2 }}></Typography>
                       


                        <div className='cussec'>
<section class="mep-content">
 <h1><b>Industrial Electrical Contractors In India</b></h1>

<p>
Power systems shape how factories breathe, move, and perform each day. Behind every stable operation sits electrical planning that respects safety, scale, and future growth.
</p>

<p>
At <a href="https://www.uniqueengineersltd.com/"><b>Unique Engineers</b></a>, we approach industrial environments with this responsibility firmly in mind. Our teams work alongside plant managers, consultants, and project heads, not above them.
</p>

<p>
We design, execute, and maintain electrical systems that remain dependable under real operational pressure. The focus always stays on continuity, compliance, and long term reliability.
</p>

<h2><b>Electrical Engineering That Understands Industrial Reality</b></h2>

<p>
Industrial electrical systems demand discipline, foresight, and practical judgement. Design errors surface later as downtime, safety risks, or expensive retrofits. Our engineers begin by understanding load behaviour, process sensitivity, and site limitations. Every recommendation follows operational logic rather than theoretical perfection.
</p>

<p>
We work across manufacturing plants, logistics parks, data driven facilities, and infrastructure projects. Each site brings unique voltage demands, redundancy expectations, and compliance requirements. Our approach respects these differences rather than forcing uniform solutions. This thinking defines our role among industrial electrical contractors in India.
</p>

<h2><b>Integrated Electrical Planning For Long Term Stability</b></h2>

<p>
Electrical infrastructure should support growth without repeated disruption. Planning therefore focuses on scalability, service access, and system resilience. Our drawings, layouts, and specifications are developed with future expansions in mind.
</p>

<p>
We align electrical planning with HVAC, fire safety, and building management systems. This coordination avoids clashes that usually surface during commissioning stages. Clients experience smoother handovers and predictable performance from day one.
</p>

<p>
This integrated mindset often places us alongside a reputed <a href="https://www.uniqueengineersltd.com/services/hvac-company-in-india/"><b>HVAC company in India</b></a> during large projects. The collaboration remains technical, balanced, and execution focused.
</p>

<h2><b>Execution Standards That Respect Safety And Compliance</b></h2>

<p>
Execution quality defines how drawings perform under operational load. Our site teams follow structured processes backed by detailed checklists. Each activity undergoes supervision, testing, and documentation.
</p>

<p>
We adhere to Indian electrical codes, safety norms, and client specific standards. Testing protocols include insulation resistance, earth continuity, and load validation. Documentation supports audits, maintenance planning, and statutory inspections.
</p>

<p>
These practices allow our electrical scope to integrate seamlessly within a broader <a href="https://www.uniqueengineersltd.com/"><b>MEP company in India</b></a> structure. Coordination remains calm, professional, and schedule aligned.
</p>

<h2><b>Electrical Systems Delivered With Measured Precision</b></h2>

<p>
Electrical contracting extends beyond cables and panels. It includes control logic, protection systems, and operational continuity. Our scope covers high tension and low tension installations, panels, cabling, and automation interfaces.
</p>

<p>
After commissioning, systems behave predictably during peak loads and fluctuations. Maintenance teams receive clear documentation and system understanding. Clients avoid dependency on emergency interventions.
</p>

<p>
This approach reflects our role as a trusted <a href="https://www.uniqueengineersltd.com/services/mepf-contractor-in-india/"><b>MEPF Contractor in India</b></a> for complex industrial facilities.
</p>

<h2><b>Disciplined Project Management On Active Industrial Sites</b></h2>

<p>
Industrial sites rarely pause operations for construction activities. Electrical work therefore demands coordination with live environments. Our teams plan shutdowns, diversions, and sequencing with plant stakeholders.
</p>

<p>
After initial assessments, work packages are divided into controlled phases. This reduces operational disruption and protects personnel safety. Communication remains direct and practical throughout execution.
</p>

<p>
This discipline aligns us naturally with <a href="https://www.uniqueengineersltd.com/services/industrial-fire-fighting-contractors-in-india/"><b>Industrial fire fighting contractors in India</b></a> during integrated safety projects.
</p>

<h3><b>Electrical Infrastructure That Complements Environmental Control</b></h3>

<p>
Industrial environments depend heavily on stable electrical support for thermal control. Electrical systems therefore influence cooling performance and energy efficiency. We design electrical layouts that support high load HVAC equipment without stress.
</p>

<p>
This balance becomes essential when coordinating with an <a href="https://www.uniqueengineersltd.com/services/air-conditioning-contractor-in-india/"><b>air conditioning contractor in India</b></a> on large facilities. Electrical provisions remain sufficient without unnecessary oversizing. The result is predictable performance and controlled energy consumption.
</p>

<h3><b>Why Industrial Clients Work With Unique Engineers</b></h3>

<p>
Clients value partners who understand site realities rather than selling ideals. Our role stays technical, consultative, and accountable. Decisions are explained clearly, not hidden behind complex language.
</p>

<p>
We focus on long term reliability rather than short term completion alone. This mindset reduces lifecycle costs and operational uncertainty. It also builds trust that continues beyond project handover.
</p>
   
</section>

                        </div>

                    </Grid>
                </Grid>
            </Grid>
            <Grid item sx={{backgroundColor:'#F4F8FA', mt:'-3em', position:'relative', zIndex:1, px: !isMobile ? 10 : 2.5, width:'100%', display:'flex', justifyContent:'center'}}>
                <Grid item sx={{width:'100%', px:!isMobile ? 10 : 0, pt: !isMobile ? '5em' : '3em', pb: !isMobile ? '5em' : '3em'  }}>
                    <Grid item sx={{}}>
                        <Typography className='titleStyle title-color' sx={{ pb:'1em', textAlign: 'center'}}>Safety served with comfort</Typography>
                        <Grid item sx={{width:'100%', display:'flex', pb: !isMobile && '2em' }}>
                            <Grid item xs={4} sx={{}}>
                                <Typography className='titleStyle title-color' sx={{ pb:0, fontFamily:'Inter !important', fontWeight:'700 !important', textAlign:'center'}}>
                                    { numberBool &&  <p class="numbers">
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--1" data-fake="4642210061">4</span>
                                        </span>
                                    </p>
                                    }
                                </Typography>
                                <Typography className='normal-text' sx={{pb:2, textAlign:'center'}}>Stadiums <br/> made spacious</Typography>
                            </Grid>
                            <Grid item xs={4} sx={{}}>
                                <Waypoint onEnter={() => setNumberBool(true)} />
                                <Typography className='titleStyle title-color' sx={{ pb:0, fontFamily:'Inter !important', fontWeight:'700 !important', textAlign:'center'}}>
                                    { numberBool &&  <p class="numbers">
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--1" data-fake="6642212862">6</span>
                                        </span>
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--2" data-fake="8641218062">8</span>
                                        </span>
                                    </p>
                                    }
                                </Typography>
                                <Typography className='normal-text' sx={{pb:2, textAlign:'center'}}>Stress-free and <br/> comfortable hospitals </Typography>
                            </Grid>
                            <Grid item xs={4} sx={{}}>
                                <Typography className='titleStyle title-color' sx={{ pb:0, fontFamily:'Inter !important', fontWeight:'700 !important', textAlign:'center'}}>
                                    { numberBool &&  <p class="numbers">
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--1" data-fake="5612210038">5</span>
                                        </span>
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--2" data-fake="8824918502">8</span>
                                        </span>
                                    </p>
                                    }
                                </Typography>
                                <Typography className='normal-text' sx={{pb:2, textAlign:'center'}}>Industries <br/> innovated for</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <FootPrint title='Our projects' imageArray = {slides} content='We offer unique solutions for every project we undertake and our experts examine the details minutely. We also take pride in providing sustainable solutions that minimize our carbon footprint or impact on environment.' />
            <Testimonial title={'Words of satisfaction'}  />

            <> 
            <Grid item  className='title-div'
            // sx={{px:!isMobile ? 10 : 0, width:'100%', maxWidth:1440, display:'flex', justifyContent:'center', pt:'2em'}}
            >
            <Grid item sx={{px: !isMobile && 12.5}}>
            <Grid item xs={12} sx={{pt:'2em', pb: !isMobile ? '8em' : '6em'}}>
            <div container style={{width:'100%', justifyContent:'center', margin:'0px 0px 0px'}}>
            <div class="cussec cusmargnsec2"> 
 
        
        <h4><b>Frequently Asked Questions</b></h4>

        
<details open className='cusfq'>
  <summary>What industries do you serve as industrial electrical contractors in India?</summary>
  <p>We work with manufacturing plants, warehouses, logistics hubs, commercial infrastructure, and specialised industrial facilities.</p>
</details>


<details className='cusfq'>
  <summary>How do you ensure safety during live electrical installations?</summary>
  <p>We follow strict isolation procedures, phased shutdown planning, and continuous supervision during all site activities.
</p>
</details>


<details className='cusfq'>
  <summary>Do you support future expansion during electrical design?</summary>
  <p>Yes, our designs include capacity planning, spare provisions, and access considerations for future growth.
</p>
</details>

<details className='cusfq'>
  <summary>How do you coordinate with other engineering disciplines on site?</summary>
  <p>We collaborate closely with mechanical, fire safety, and automation teams through integrated planning and regular coordination reviews.
</p>
</details>

<details className='cusfq'>
  <summary>Do you provide documentation after project completion?</summary>
  <p>Yes, we hand over complete drawings, test reports, and compliance records for maintenance and audits.
</p>
</details>



            </div>
            </div>   
            </Grid></Grid></Grid>
            </>

        </Grid>
    </Grid>
)

}

export default HtltService;